module.exports = __webpack_public_path__ + "static/media/test30.49f0293e.jpeg";